import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { IdObjectFormModel } from "projects/assist/src/app/_shared/form/form-models/form-model";
import { CustomEntityObject } from "../../custom-entity/models/custom-entity-object";
import { PersonFormFieldList } from "../../forms/models/person-form";
import { AddressList, AddressWithPersons } from "../models/address";

export class AddressFormModel extends IdObjectFormModel<AddressList> {
  constructor(
    model: AddressList = {} as AddressList,
    readonly fb: FormBuilder = new FormBuilder(),
    private customObject?: CustomEntityObject,
    private waitingListFiels?: PersonFormFieldList[],
    protected myAssist = false
  ) {
    super(
      model,
      fb.group({
        OrganizationId: [model.OrganizationId],
        AddressTypeId: [model.AddressTypeId || 4],
        Name: [model.Name],
        NameTicket: [model.NameTicket],
        Street: [model.Street],
        Nr: [model.Nr],
        Bus: [model.Bus],
        PostCode: [model.PostCode],
        Location: [model.Location],
        Province: [model.Province],
        GSM: [model.GSM],
        HomePhone: [model.HomePhone],
        Email: [model.Email],
        Website: [model.Website],
        Country: [model.Country],
        Fax: [model.Fax],
        JuridicStatuteId: [model.JuridicStatuteId],
        Building: [model.Building],
        IsSwimmingPool: [model.IsSwimmingPool],
        Family: [model.Family],
        AddressGroupId: [model.AddressGroupId],
        Short: [model.Short],
        MoreInformation: [model.MoreInformation],
        AccountNumber: [model.AccountNumber],
        Iban: [model.Iban],
        Bic: [model.Bic],
        FollowNumber: [model.FollowNumber],
        EnterpriseNumber: [model.EnterpriseNumber, { updateOn: "blur" }],
        customJuridicStatute: [model.customJuridicStatute],
        IsUsedForCompetitions: [model.IsUsedForCompetitions],
        LengthOfPool: [model.LengthOfPool],
        DateOfLastExamination: [model.DateOfLastExamination],
        Gewest: [model.Gewest],
        Latitude: [model.Latitude],
        Longitude: [model.Longitude],
        VatNumber: [model.VatNumber, { updateOn: "blur" }],
        ExternalId: [model.ExternalId],
        MatchScore: [model.MatchScore],
      })
    );
    if (waitingListFiels) {
      console.log("Adress");
      waitingListFiels.forEach((field) => {
        if (
          field.Required &&
          field.CustomEntityField.CustomEntityDefaultField &&
          field.CustomEntityField.CustomEntityPartId == 2
        ) {
          if (field.CustomEntityField.CustomEntityDefaultField.TypeName != null) {
            console.log(field.CustomEntityField.CustomEntityDefaultField.TypeName);
            this.get(
              field.CustomEntityField.CustomEntityDefaultField.TypeName.replace(
                "HomeAddress.",
                ""
              ).trim()
            )?.addValidators(Validators.required);
            if (field.CustomEntityField.CustomEntityDefaultField.Id === 4) {
              //When street is required, also set Nr required
              this.Nr.addValidators(Validators.required);
            }
          }
        }
      });
    } else if (customObject) {
      customObject.CustomEntityFieldValues.forEach((field) => {
        if (
          (myAssist ? field.CustomEntityField.RequiredPublic : field.CustomEntityField.Required) && // of Required?
          field.CustomEntityField.CustomEntityDefaultField &&
          field.CustomEntityField.CustomEntityPartId == 2 &&
          field.CustomEntityField.CustomEntityDefaultField.TypeName
        ) {
          this.get(
            field.CustomEntityField.CustomEntityDefaultField.TypeName.replace(
              "HomeAddress.",
              ""
            ).trim()
          )?.addValidators(Validators.required);
          if (field.CustomEntityField.CustomEntityDefaultField.Id === 4) {
            //When street is required, also set Nr required
            this.Nr.addValidators(Validators.required);
          }
        }
      });
    }
  }

  readonly OrganizationId = this.get("OrganizationId") as FormControl;
  readonly AddressTypeId = this.get("AddressTypeId") as FormControl;
  readonly Name = this.get("Name") as FormControl<string>;
  readonly NameTicket = this.get("NameTicket") as FormControl;
  readonly Street = this.get("Street") as FormControl;
  readonly Nr = this.get("Nr") as FormControl;
  readonly Bus = this.get("Bus") as FormControl;
  readonly PostCode = this.get("PostCode") as FormControl;
  readonly Location = this.get("Location") as FormControl;
  readonly Province = this.get("Province") as FormControl;
  readonly GSM = this.get("GSM") as FormControl;
  readonly HomePhone = this.get("HomePhone") as FormControl;
  readonly Email = this.get("Email") as FormControl;
  readonly Website = this.get("Website") as FormControl;
  readonly Country = this.get("Country") as FormControl;
  readonly Fax = this.get("Fax") as FormControl;
  readonly JuridicStatuteId = this.get("JuridicStatuteId") as FormControl;
  readonly Building = this.get("Building") as FormControl;
  readonly IsSwimmingPool = this.get("IsSwimmingPool") as FormControl;
  readonly Family = this.get("Family") as FormControl;
  readonly AddressGroupId = this.get("AddressGroupId") as FormControl;
  readonly Short = this.get("Short") as FormControl;
  readonly MoreInformation = this.get("MoreInformation") as FormControl;
  readonly AccountNumber = this.get("AccountNumber") as FormControl;
  readonly Iban = this.get("Iban") as FormControl;
  readonly Bic = this.get("Bic") as FormControl;
  readonly FollowNumber = this.get("FollowNumber") as FormControl;
  readonly EnterpriseNumber = this.get("EnterpriseNumber") as FormControl;
  readonly customJuridicStatute = this.get("customJuridicStatute") as FormControl;
  readonly IsUsedForCompetitions = this.get("IsUsedForCompetitions") as FormControl;
  readonly LengthOfPool = this.get("LengthOfPool") as FormControl;
  readonly DateOfLastExamination = this.get("DateOfLastExamination") as FormControl;
  readonly Gewest = this.get("Gewest") as FormControl;
  readonly Latitude = this.get("Latitude") as FormControl;
  readonly Longitude = this.get("Longitude") as FormControl;
  readonly VatNumber = this.get("VatNumber") as FormControl;
  readonly ExternalId = this.get("ExternalId") as FormControl;
  readonly MatchScore = this.get("MatchScore") as FormControl;

  isInBelgium(): boolean {
    if (
      !this.Country.value ||
      this.Country.value.toLowerCase().indexOf("belgi") !== -1 ||
      this.Country.value.toLowerCase() == "be" ||
      this.Country.value.toLowerCase() == "bel"
    ) {
      return true;
    }
    return false;
  }

  mapToAddressWithPersons(): AddressWithPersons {
    Object.assign(this.model, { ...this.getRawValue() } as AddressWithPersons);
    if (!this.model.Id) this.model.Id = 0;
    return this.model as AddressWithPersons;
  }

  override mapToModel(): AddressList {
    let model = super.mapToModel();
    if (!model.Id) model.Id = 0;
    return model;
  }
}
